export var ALL = 0;
export var HR1 = 1;
export var HR12 = 12;
export var HR24 = 24;



// WEBPACK FOOTER //
// ./src/constants/TimeFilter.js